import React, { useState } from 'react'
import './Module.scss';
import ModuleRoutes from './Module.routes';
import Navbar from '../../components/design/navbar/Navbar';
import Footer from '../../components/design/footer/Footer';
import ScrollToTop from '../../components/content/ScrollToTop';

function Module() {

    // Estado para almacenar el nombre de la página actual
    const [pageTitle, setPageTitle]: [string, any] = useState('');

    return (
        <section className='content_module'>
            <ScrollToTop />

            <div className='module'>
                <Navbar pageTitle={pageTitle} />

                <div className='container'>
                    <ModuleRoutes
                        setPageTitle={setPageTitle}
                    />
                </div>
            </div>

            <div className='content_end'>
                <Footer />
            </div>
        </section>
    )
}

export default Module;
